import API from "./../../../utils/api";

export const getShippingPayersApi = async (filters) => {
  const response = await API.get("settings/shipping-payer", { params: filters });
  return { response };
};

export const addShippingPayersApi = async (data) => {
  const response = await API.post("settings/shipping-payer", data);
  return { response };
};

export const updateShippingPayersApi = async (data, id) => {
  const response = await API.put(`settings/shipping-payer/${id}`, data);
  return { response };
};

export const deleteShippingPayersApi = async (id) => {
  const response = await API.delete(`settings/shipping-payer/${id}`);
  return { response };
};
